import { Config, PixelStreaming, Flags, SettingText } from '@epicgames-ps/lib-pixelstreamingfrontend-ue5.2'
import { Application, PixelStreamingApplicationStyle, UIElementCreationMode} from '@epicgames-ps/lib-pixelstreamingfrontend-ui-ue5.2'
import eventBus from './eventBus.js'

var streamUE = null
// var streamContainer = null
// var streamRoot = null
var currentScene = null

function switchTags(tagName) {
  if (streamUE != null) {
    const msg = {
      function : 'switchTags',
      content : {
         name: tagName 
      }
    }
    streamUE.emitUIInteraction(JSON.stringify(msg))
  }
}

function showTags(tagName) {
  if (streamUE != null) {
    const msg = {
      function : 'showTags',
      content : {
         name: tagName 
      }
    }
    streamUE.emitUIInteraction(JSON.stringify(msg))
  }
}

function setGates(data) {
  if (streamUE != null) {
    const msg = {
      function : 'setGates',
      content : {
         data: data 
      }
    }
    streamUE.emitUIInteraction(JSON.stringify(msg))
  }
}

function hideTags(tagName) {
  if (streamUE != null) {
    const msg = {
      function : 'hideTags',
      content : {
         name: tagName 
      }
    }
    streamUE.emitUIInteraction(JSON.stringify(msg))
  }
}

function spawnTags(list) {
  if (streamUE != null) {
    const msg = {
      function : 'spawnSPW',
      content : {
         data: list 
      }
    }
    streamUE.emitUIInteraction(JSON.stringify(msg))
  }
}

function spawnTagsD(list) {
  if (streamUE != null) {
    const msg = {
      function : 'spawnSPWD',
      content : {
         data: list 
      }
    }
    streamUE.emitUIInteraction(JSON.stringify(msg))
  }
}

function moveCamera(lookAt) {
  if (streamUE != null) {
    const msg = {
      function : 'moveCamera',
      content : {
        target: lookAt
      }
    }
    streamUE.emitUIInteraction(JSON.stringify(msg))
  }
}

function focusPoint(name,x, y) {
  if (streamUE != null) {
    const msg = {
      function : 'focusPoint',
      content : { 
        name: name,
        x: x, 
        y: y 
      }
    }
    streamUE.emitUIInteraction(JSON.stringify(msg))
  }
}

function spawnPOIs(data,type) {
  if (streamUE != null) {
    const msg = {
      function : 'spawnWC',
      content :  { 
        data: data,
        type: type
      }
    }
    streamUE.emitUIInteraction(JSON.stringify(msg))
  }
}

function focusCamera(cameraCode) {
  if (streamUE != null) {
    const msg = {
      function : 'focusCamera',
      content : { 
        data: cameraCode
      }
    }
    streamUE.emitUIInteraction(JSON.stringify(msg))
  }
}

function highlightBuilding(name) {
  if (streamUE != null) {
    const msg = {
      function : 'highlightBuilding',
      content : { 
        name: name
      }
    }
    streamUE.emitUIInteraction(JSON.stringify(msg))
  }
}

function QuitGame(){
  if (streamUE != null) {
    const msg = {
      function : 'Quit',
      content : {
        data: ''
      }
    }
    // streamUE.emitUIInteraction(JSON.stringify(msg))
  }
}

function onEvent(response){
  if(streamUE !== null)
  {
    console.log(response)
    const res = JSON.parse(response)
    switch(res.function){
      case 'callCamera':
        console.log(res.data)
        eventBus.$emit('setCamera', res.data)
        break
      case 'showWBDW':
        // eventBus.$emit('closePop1')
        eventBus.$emit('openPop1', res.data.id)
        break
      case 'showYDP':
        // eventBus.$emit('closePop1')
        eventBus.$emit('openSecondPop3', res.data.code)
        break
      case 'hideWBDW':
        eventBus.$emit('closePop1')
        break
      case 'hideAllPopup':
        eventBus.$emit('closeAllPopup')
        break
      case 'showWC':
        eventBus.$emit('openSecondPop1')
        break
      case 'showYDP':
        eventBus.$emit('openSecondPop3')
        break
    }
  }
}

function onReady(){
  console.log('isReady')
  moveCamera(currentScene)
  eventBus.$emit('setJKG')
}

function close(){
  if(streamUE !== null)
  {
    // document.getElementById(streamContainer).removeChild(streamRoot)
    streamUE.disconnect()
  }
}

function init(CustomConfig) {
  // if(streamUE !== null)
  // {
  //   streamUE.disconnect()
  //   streamUE = null
  // }
  const MyPixelStreamingApplicationStyle = new PixelStreamingApplicationStyle()
  MyPixelStreamingApplicationStyle.applyStyleSheet()

  const config = new Config({
    useUrlParams: true,
  })
  config.setFlagEnabled(Flags.AutoConnect, true)
  config.setFlagEnabled(Flags.AutoPlayVideo, true)
  config.setFlagEnabled(Flags.StartVideoMuted, true)
  config.setFlagEnabled(Flags.HoveringMouseMode, true)
  config.setFlagEnabled(Flags.KeyboardInput,false)
  config.setFlagEnabled(Flags.MatchViewportResolution,true)
  config.setTextSetting('ss',CustomConfig.streamAddress)

  const stream = new PixelStreaming(config)

  stream.addResponseEventListener("handle_responses",onEvent)
  stream.addEventListener("videoInitialized",onReady)

  const application = new Application({
    stream,
    onColorModeChanged: (isLightMode) => MyPixelStreamingApplicationStyle.setColorMode(isLightMode),
    settingsPanelConfig: {
      isEnabled : false,
      visibilityButtonConfig : {creationMode : UIElementCreationMode.Disable}
    },
    statsPanelConfig: {
      isEnabled : false,
      visibilityButtonConfig : {creationMode : UIElementCreationMode.Disable}
    },
    fullScreenControlsConfig: {
      isEnabled : false,
      visibilityButtonConfig : {creationMode : UIElementCreationMode.Disable}
    },
    xrControlsConfig: {
      isEnabled : false,
      visibilityButtonConfig : {creationMode : UIElementCreationMode.Disable}
    },
    videoQpIndicatorConfig: {
      isEnabled : false,
      disableIndicator : true,
      visibilityButtonConfig : {creationMode : UIElementCreationMode.Disable}
    }
  })
  document.getElementById(CustomConfig.htmlElement).appendChild(application.rootElement)
  streamUE = stream
  currentScene = CustomConfig.scene
  // streamContainer = CustomConfig.htmlElement
  // streamRoot = application.rootElement
}

export {
  init,
  close,
  QuitGame,
  moveCamera,
  setGates,
  showTags,
  hideTags,
  spawnTags,
  spawnTagsD,
  switchTags,
  focusPoint,
  spawnPOIs,
  focusCamera,
  highlightBuilding,
}

